// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"9026ccc2d50916c1ca92","303":"8a5ede8e6604db94ffb6","495":"f10b151ad6ae88664f48"}[chunkId] + ".js";
};